<template>
    <div id="banner" :style="{backgroundImage:'url('+ banner_bg +')'}">
        <div class="container">
            <div class="page-title">
                <div class="main-en">{{mainen}}</div>
                <div class="main-zh">{{mainzh}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import bannerBg from "@/assets/imgs/b6.jpg"

export default {
   name:'banner',
   props: ['mainen','mainzh'],
   data(){
       return {
           banner_bg: bannerBg,
       }
   },

}
</script>
<style scoped>
    #banner{
        position: flex;
        justify-content: center;
        width:100%;
        height:478px;
    }

    #banner .container{
        width:1200px;
        height: 100%;
        position: relative;
    }

    #banner .page-title{
        position: absolute;
        left:60px;
        bottom:87px;
    }

    #banner .page-title .main-en{
        font-family: "Arial Narrow";
        font-size: 54px;
        color:white;
        font-weight: bold;
    }

#banner .page-title .main-en::before{
    content:"";
    width:26px;
    height: 5px;
    background-color: white;
    position: absolute;
    left:-43px;
    top: 31px;
    
}

     #banner .page-title .main-zh{
         font-family: "Arial Narrow";
         font-size: 26px;
         color:white;
         font-weight: bold;
     }
</style>



// WEBPACK FOOTER //
// src/components/sub/Banner.vue